export default __webpack_public_path__ + "static/media/YogaClub.3c45b661.png";